import apiAxios from 'helpers/apiAxios';

const BASE = '/monitoring/orphan_attachments';

// The phrase the server also checks. A purge without it fails on the backend,
// so this constant is a UI mirror of a server-side rule, not the rule itself.
export const CONFIRMATION_PHRASE = 'DELETE';

const message = (error, fallback) =>
  error?.response?.data?.error || error?.message || fallback;

export const fetchOrphans = async ({ recordType, name, page, perPage }) => {
  try {
    const res = await apiAxios.get(BASE, {
      params: {
        record_type: recordType || undefined,
        name: name || undefined,
        page,
        per_page: perPage,
      },
    });
    return { rows: res.data?.data || [], meta: res.data?.meta || {} };
  } catch (error) {
    throw new Error(message(error, 'Could not load orphan attachments.'));
  }
};

// dryRun defaults to true on the server too: the destructive call is the one
// that has to be asked for explicitly, never the other way round.
export const purgeOrphans = async ({ ids, dryRun = true }) => {
  try {
    const res = await apiAxios.post(`${BASE}/purge`, {
      ids,
      dry_run: dryRun,
      confirmation: dryRun ? undefined : CONFIRMATION_PHRASE,
    });
    return res.data?.data || {};
  } catch (error) {
    throw new Error(message(error, 'Could not remove the selected attachments.'));
  }
};
